
import React, { useEffect, useState } from 'react';

import HemaFullLogo from '../assets/HemaLogo.png';
import HemaIcon from '../assets/SmallLogo.png';

let hemaStylesInjected = false;
function injectHemaStyles() {
  if (hemaStylesInjected) return;
  if (typeof document === 'undefined') return;

  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes hema-spin {
      from { transform: rotate(0deg); }
      to   { transform: rotate(360deg); }
    }

    @keyframes hema-spin-once {
      from { transform: rotate(0deg); }
      to   { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
  hemaStylesInjected = true;
}

const LoadingScreen = ({ onFinished }) => {
  const [showWord, setShowWord] = useState(false);

  useEffect(() => {
    injectHemaStyles();

    const t1 = setTimeout(() => {
      setShowWord(true);
    }, 900);

    const t2 = setTimeout(() => {
      if (typeof onFinished === 'function') {
        onFinished();
      }
    }, 1900);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onFinished]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
      style={{

        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.2) 0%, rgba(40, 227, 218, 0) 100%), #081423'
      }}
      dir="rtl"
    >
      {                                    }
      <div className="absolute inset-0 w-full h-full pointer-events-none">
        <img
          src="/images/stars.png"
          alt=""
          className="w-full h-full object-cover opacity-80"
        />
      </div>

      {                         }
      <div className="relative z-10">
        <div
        >
          <div
            className="w-full h-full flex items-center justify-center"
            style={{ padding: '12px 16px' }}
          >
            {                                                }
            {!showWord && (
              <img
                src={HemaIcon}
                alt="Hemma Logo"
                style={{
                  width: '56px',
                  height: '56px',
                  animation: 'hema-spin 1.1s linear infinite'
                }}
              />
            )}

            {                                                }
            {showWord && (
              <div
                className="flex items-center justify-center gap-3"
                style={{ flexDirection: 'row-reverse' }}
              >
                <img
                  src={HemaFullLogo}
                  alt="Hemma"
                  style={{
                    height: '26px',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 0 12px rgba(40,227,218,0.55))'
                  }}
                />
                <img
                  src={HemaIcon}
                  alt="Hemma Icon"
                  style={{
                    width: '40px',
                    height: '40px',
                    animation: 'hema-spin-once 0.7s ease-out 1'
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
